var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbnailNotAvailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "c716f3be-4b97-4bae-81be-4ac5480de042"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "659184e9-1495-4736-9b80-e225ce87d1bf"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(33.33 0 0 33.33 -0.03 -0.04)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(165,165,165)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-12, -12)",
    d: "M 3.28034 2.21968 C 2.98745 1.92678 2.51257 1.92677 2.21968 2.21966 C 1.92678 2.51255 1.92677 2.98743 2.21966 3.28032 L 3.48327 4.54395 C 3.17684 5.03983 3 5.62427 3 6.25001 L 3 17.75 C 3 19.5449 4.45507 21 6.25 21 L 17.75 21 C 18.3757 21 18.96 20.8232 19.4559 20.5169 L 20.7194 21.7805 C 21.0123 22.0734 21.4872 22.0734 21.7801 21.7805 C 22.073 21.4876 22.073 21.0127 21.7801 20.7198 L 3.28034 2.21968 Z M 12.0681 13.1289 L 18.2739 19.3349 C 18.2929 19.3572 18.3118 19.3794 18.3305 19.4014 C 18.1489 19.4653 17.9535 19.5 17.75 19.5 L 6.25 19.5 C 6.04613 19.5 5.8504 19.4651 5.66845 19.4011 L 11.4752 13.7148 L 12.0681 13.1289 Z M 11.1189 12.1797 C 10.8678 12.2865 10.6322 12.4409 10.4258 12.643 L 4.60326 18.3437 C 4.53643 18.1583 4.5 17.9584 4.5 17.75 L 4.5 6.25001 C 4.5 6.04371 4.5357 5.84575 4.60125 5.66196 L 11.1189 12.1797 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(33.33 0 0 33.33 53.02 -53.06)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(165,165,165)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-13.59, -10.41)",
    d: "M 19.5 16.3183 L 19.5 6.25001 C 19.5 5.28351 18.7165 4.50001 17.75 4.50001 L 7.68194 4.50001 L 6.18265 3.00069 C 6.20505 3.00024 6.2275 3.00001 6.25 3.00001 L 17.75 3.00001 C 19.5449 3.00001 21 4.45508 21 6.25001 L 21 17.75 C 21 17.7726 20.9998 17.7952 20.9993 17.8176 L 19.5 16.3183 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(33.33 0 0 33.33 108.4 -108.28)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(165,165,165)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-15.25, -8.75)",
    d: "M 15.2521 6.50001 C 16.4959 6.50001 17.5042 7.50832 17.5042 8.75212 C 17.5042 9.99593 16.4959 11.0042 15.2521 11.0042 C 14.0083 11.0042 13 9.99593 13 8.75212 C 13 7.50832 14.0083 6.50001 15.2521 6.50001 Z M 15.2521 8.00001 C 14.8367 8.00001 14.5 8.33674 14.5 8.75212 C 14.5 9.16751 14.8367 9.50424 15.2521 9.50424 C 15.6675 9.50424 16.0042 9.16751 16.0042 8.75212 C 16.0042 8.33674 15.6675 8.00001 15.2521 8.00001 Z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailNotAvailable);
export default __webpack_public_path__ + "static/media/thumbnail_not_available.5cd90061eec6a46df3f459ad19815d56.svg";
export { ForwardRef as ReactComponent };